import React, { useContext, createContext } from "react";
import { Route, Routes } from "react-router-dom";
import { getUserId } from "./lib/auth";
import { getIdData } from "./lib/profiles";
import { UserContext, UserProvider } from "./usercontext";
/*
git add .
git commit -m "06/08/2024 Update"
git push -f origin dev
*/
import ComingSoon from "./components/pages/error/comingSoon";
import Error404 from "./components/pages/error/error404";
import Error500 from "./components/pages/error/error500";
import UnderConstruction from "./components/pages/error/underConstruction";
import ForgotPassword from "./components/pages/forgotPassword";
import Login from "./components/pages/login";
import PrivacyPolicy from "./components/pages/policy";
import Register from "./components/pages/register";
import NewPassword from "./components/pages/newPassword";
import RegisterOne from "./components/pages/register/register1";
import RegisterTwo from "./components/pages/register/register2";
import RegisterThree from "./components/pages/register/register3";
import RegisterFour from "./components/pages/register/register4";
import RegisterFive from "./components/pages/register/register5";
import Support from "./components/pages/support";
import TermsCondition from "./components/pages/termsCondition";

//harish
import { Home } from "./components/home";
import { Home2 } from "./components/home2";
import { Home3 } from "./components/home3";
import { Home4 } from "./components/home4";
import { Dashboard } from "./components/instructor/dashboard";
import { InstructorList } from "./components/instructor/list";
import InstructorGrid from "./components/instructor/grid";
import InstructorCourse from "./components/instructor/course";
import InstructorReviews from "./components/instructor/reviews";
import InstructorEarnings from "./components/instructor/earnings";
import InstructorOrders from "./components/instructor/orders";
import InstructorPayouts from "./components/instructor/payouts";
import InstructorEditProfile2 from "./components/instructor/editProfile_";
import InstructorSecurity from "./components/instructor/security";
import InstructorSocialProfile from "./components/instructor/socialProfiles";
import InstructorNotification from "./components/instructor/notification";
import InstructorTickets from "./components/instructor/tickets";
import InstructorChat from "./components/instructor/chat";
import InstructorDeleteProfile from "./components/instructor/deleteProfile";
import InstructorEdit from "./components/instructor/edit";
import InstructorGrid2 from "./components/instructor/grid2";
import InstructorLinkedAccount from "./components/instructor/linkedAccount";
import InstructorNewTickets from "./components/instructor/newTickets";
import InstructorProfile2 from "./components/instructor/profile";
import InstructorProfilePrivacy from "./components/instructor/profilePrivacy";
import InstructorStudentList from "./components/instructor/studentList";
import StudentProfile from "./components/student/editProfile";
import StudentProfileEdit from "./components/student/editProfile/studentprofileedit";
import StudentNotification from "./components/student/notification";
import StudentPrivacy from "./components/student/privacy";
import StudentReferral from "./components/student/referral";
import StudentSecurity from "./components/student/security";
import StudentSubscription from "./components/student/subscription";
import StudentNewTickets from "./components/student/newTickets";
import StudentTickets from "./components/student/tickets";
import StudentViewTickets from "./components/student/viewTickets";
import StudentsGrid from "./components/student/grid";
import StudentsGrid2 from "./components/student/grid2";
import StudentsList from "./components/student/list";
import InstructorDepositDashboard from "./components/instructor/deposit";
import DashboardInstructor from "./components/instructor/dashboardInstructor";
import WithdrawalInstructor from "./components/instructor/withdrawalInstructor";
import DepositInstructor from "./components/instructor/depositInstructor";
import TransactionInstructor from "./components/instructor/transactionInstructor";
import InstructorNewSchedule from "./components/instructor/schedule/newschedule";
import InstructorScheduleDays from "./components/instructor/schedule/scheduledays";

//Admin
import AdminLayout from "./components/admin/layout";
import AdminProfile from "./components/admin/editProfile";
import AdminProfileEdit from "./components/admin/editProfile/editProfile";
import { DashboardAdmin } from "./components/admin/dashboard";
import AdminStudentGrid from "./components/admin/studentGrid";
import AdminStudentList from "./components/admin/studentList";
import AdminDragDrop from "./components/admin/dragdrop";
import AdminParameters from "./components/admin/parameters";
import AdminParametersEdit from "./components/admin/parameters/parametersedit";
import AdminBookList from "./components/admin/booklist";
import AdminBookListEdit from "./components/admin/booklist/booklistedit";
import AdminPersonalQuestions from "./components/admin/personalquestions";
import AdminPersonalQuestionEdit from "./components/admin/personalquestions/personalquestionedit";
import AdminAppCheck from "./components/admin/appcheck";
import AdminAppCheckEdit from "./components/admin/appcheck/appcheckedit";
import AdminStudentEdit from "./components/admin/student";
import AdminAddStudentStep2 from "./components/admin/student/addstudentstep2";
import AdminAddStudentStep3 from "./components/admin/student/addstudentstep3";
import AdminStudentRoleUpdate from "./components/admin/student/studentroleupdate";
import AdminStudentDetail from "./components/admin/studentGrid/studentdetail";
import AdminStudentBookList from "./components/admin/studentGrid/studentbooklist";
import AdminStudentAppCheck from "./components/admin/studentGrid/studentappcheck";
import AdminStudentGoalGrades from "./components/admin/studentGrid/studentgoalgrades";
import AdminStudentPersonalQuestion from "./components/admin/studentGrid/studentpersonelquestion";
import AdminStudentPersonalQuestionEdit from "./components/admin/studentGrid/studentpersonalquestionedit";
import AdminStudentGradeList from "./components/admin/studentGrid/studentgradelist";
import AdminClassList from "./components/admin/class";
import AdminClassEdit from "./components/admin/class/classedit";
import AdminStudentToClass from "./components/admin/class/studenttoclass";
import AdminInstructorGrid from "./components/admin/instructorGrid";
import AdminInstructorEdit from "./components/admin/instructor";
import AdminAddInstructorStep2 from "./components/admin/instructor/addinstructorstep2";
import AdminAddInstructorStep3 from "./components/admin/instructor/addinstructorstep3";
import AdminInstructorDetail from "./components/admin/instructorGrid/intructordetail";
import TaskManageList from "./components/admin/taskm";
import TaskManage from "./components/admin/taskm/taskmanage";
import TaskManageDetail from "./components/admin/taskm/taskdetail";
import AdminDesiredColleges from "./components/admin/desiredcolleges";
import AdminDesiredCollegesEdit from "./components/admin/desiredcolleges/desiredcollegesedit";
import AdminLessons from "./components/admin/lessons";
import AdminLessonsEdit from "./components/admin/lessons/lessonsedit";
import AdminStudentProfile from "./components/admin/studentprofile";
import AdminStudentAplicationProfile from "./components/admin/studentGrid/studentaplicationprofile";
import AdminStudentCollegeProfile from "./components/admin/studentGrid/studentcollegeprofile";
import AdminStudentTaskManagement from "./components/admin/studentGrid/studenttaskmanagement";
import AdminParent from "./components/admin/parent";
import AdminProgressCheck from "./components/admin/progressCheck";

//instructor
import InstructorClassList from "./components/instructor/class";
import InstructorLayout from "./components/instructor/layout";
import InstructorStudentGrid from "./components/instructor/studentGrid";
import InstructorStudentDetail from "./components/instructor/studentGrid/studentdetail";
import InstructorStudentProfile from "./components/instructor/studentprofile";
import InstructorStudentProfile_2 from "./components/instructor/studentprofile_2";
import InstructorStudentBookList from "./components/instructor/studentGrid/studentbooklist";
import InstructorStudentAppCheck from "./components/instructor/studentGrid/studentappcheck";
import InstructorStudentActivityList from "./components/instructor/studentGrid/studentactivity";
import InstructorStudentProgressCheck from "./components/instructor/studentGrid/studentprogresscheck";
import InstructorStudentActivityEdit from "./components/instructor/studentGrid/studentactivityedit";
import InstructorStudentTaskList from "./components/instructor/studentGrid/studentactask";
import InstructorStudentNotesList from "./components/instructor/studentGrid/studentnotes";
import InstructorStudentPersonalQuestion from "./components/instructor/studentGrid/studentpersonelquestion";
import InstructorStudentGoalGrades from "./components/instructor/studentGrid/studentgoalgrades";
import InstructorStudentGradeList from "./components/instructor/studentGrid/studentgradelist";
import InstructorStudentTranskript from "./components/instructor/studentGrid/studenttranskript";
import InstructorStudentTranskriptEdit from "./components/instructor/studentGrid/studenttranskriptedit";
import InstructorCurriculumTable from "./components/instructor/studentGrid/studentcurriculumtable";
import InstructorStudentMainEssay from "./components/instructor/studentGrid/studentmainessay";
import InstructorStudentAdditionalInfo from "./components/instructor/studentGrid/studentaddinfo";
import InstructorProfile from "./components/instructor/editProfile";
import InstructorEditProfile from "./components/instructor/editProfile/editProfile";
import InstructorTaskManageList from "./components/instructor/taskm";
import InstructorTaskManage from "./components/instructor/taskm/taskmanage";
import InstructorTaskManageDetail from "./components/instructor/taskm/taskdetail";
import InstructorAddNewTask from "./components/instructor/taskm/addnew";
import InstructorNotes from "./components/instructor/notes";
import InstructorNotesEdit from "./components/instructor/notes/notesedit";
import InstructorStudentBragSheet from "./components/instructor/studentGrid/studentbragsheet";
import InstructorStudentResource from "./components/instructor/studentGrid/studentresource";
import InstructorDesiredColleges from "./components/instructor/desiredcolleges";
import InstructorDesiredCollegesEdit from "./components/instructor/desiredcolleges/desiredcollegesedit";
import InstructorStudentCollegeList from './components/instructor/studentGrid/sublist/studentCollegeList'
import InstructorStudentAwardsListEdit from './components/instructor/studentGrid/studentawardslistedit'

import InstructorStudentUpdate from './components/instructor/instructorStudentEdit/instructorStudentUpdate'
import InstructorStudentCheckList from './components/instructor/studentGrid/studentchecklist'
import GlobalCounselorCorner from './components/pages/common/globalcounselorcorner'
import GlobalCounselorCornerEdit from './components/pages/common/globalcounselorcorneredit'
import InstructorStudentSupplementalEssay from './components/instructor/studentGrid/studentsupplementalessay'
import InstructorStudentLesson from './components/instructor/studentGrid/studentlesson'
import InstructorStudentLessonEdit from './components/instructor/studentGrid/studentlessonedit'
import InstructorStudentLessonForGrade from './components/instructor/studentGrid/studentlessonforgrade'
import InstructorStudentLessonEditForGrade from './components/instructor/studentGrid/studentlessoneditforgrade'
import InstructorStudentSchedule from './components/instructor/studentGrid/studentschedule'
import InstStudentCollegeList from './components/instructor/collegeList/index'
import InstructorStudentSat from './components/instructor/studentSat/index'
import InstructorStudentCollegeCourses from './components/instructor/collegeCourses/index'
import InstructorStudentAwards from './components/instructor/awards/index'
import InstructorStudentProjects from './components/instructor/studentProjects/index'
import InstructorStudentCollegeVisit from './components/instructor/StudentCollegeVisit/index'
import InstructorStudentCalendar from './components/instructor/studentCalendar/index'
import InstructorStudentLor from './components/instructor/studentLor/index'
import InstructorStudentFinancialAid from './components/instructor/studentFinancialAid/index'

import InstructorStudentDeadlines from './components/instructor/studentGrid/studentdeadlines'
import InstructorStudentFinAid from './components/instructor/studentGrid/studentfinaid'
import InstructorStudentActivitiesAndAwardsIndex from './components/instructor/activitiesandawards'
import InstructorStudentCoursesReport from './components/instructor/studentGrid/studentcoursesreport'

//Parent
//import InstructorClassList from "./components/instructor/class";
import ParentLayout from './components/parent/layout'
import ParentStudentInfo from './components/parent/studentinfo'
import ParentStudentSchedule from './components/parent/schedule'
import ParentStudentNotes from './components/parent/notes'
import ParentStudentAgenda from './components/parent/taskm'
import ParentStudentTaskList from './components/parent/studentTask'
import ParentStudentProfile from './components/parent/studentprofile'
import ParentStudentProfile_2 from './components/parent/studentprofile_2'

//Student
import StudentLayout from "./components/student/layout";
import StudentBookList from "./components/student/booklist";
import StudentAppCheckList from "./components/student/appcheck";
import StudentTaskList from "./components/student/taskm";
import StudentTaskManageDetail from "./components/student/taskm/taskdetail";
import StudentLessonList from "./components/student/lessonlist";
import StudentLessons from "./components/student/lessons";
import StudentLessonsEdit from "./components/student/lessons/lessonsedit";
import StudentLessonsForGrade from "./components/student/lessons/indexforgrade";
import StudentLessonsEditForGrade from "./components/student/lessons/lessonseditforgrade";
import StudentTranskriptList from "./components/student/transkript";
import StudentTranskriptEdit from "./components/student/transkript/transkriptedit";
import StudentGradesInMonth from "./components/student/gradesinmonth";
import StudentGradesInMonthEdit from "./components/student/gradesinmonth/gradeinmonthedit";
import StudentPersonelQuestionsList from "./components/student/personalquestions";
import StudentPersonalQuestionEdit from "./components/student/personalquestions/personalquestionedit";
import StudentGoalQuestionsList from "./components/student/goalquestions";
import StudentGoalQuestionEdit from "./components/student/goalquestions/goalquestionedit";
import StudentDesiredCollegeList from "./components/student/desiredcollegelist";
import StudentActivityList from "./components/student/activity";
import StudentActivityEdit from "./components/student/activity/activityedit";
import StudentActivityReportsList from "./components/student/activityReports";
import StudentNotes from "./components/student/notes";
import StudentNotesEdit from "./components/student/notes/notesedit";
import StudentTest from "./components/student/goalquestions/test";
import StudentCurriculumTable from "./components/student/curriculumTable";
import GlobalCheckListEdit from "./components/pages/common/globalchecklistedit";
import GlobalCheckList from "./components/pages/common/globalchecklist";
import StudentCheckList from "./components/student/checklist";
import GlobalSupplementalEssayEdit from "./components/pages/common/globalsupplementalessayedit";
import GlobalSupplementalEssay from "./components/pages/common/globalsupplementalessay";
import StudentSupplementalEssay from "./components/student/supplementalessay";
import StudentMainEssay from "./components/student/mainessay";
import StudentBragSheet from "./components/student/sbragsheet";
import GlobalResource from "./components/pages/common/globalresource";
import GlobalResourceEdit from "./components/pages/common/globalresourceedit";
import StudentTask from "./components/student/studentTask";
import StudentResource from "./components/student/resource/resource";
import StudentAdditionalInfo from "./components/student/addinfo";
import StudentScheduleList from "./components/student/schedule";
import AdminCollegeList from "./components/admin/collegelistinfo/CollegeList";
import AdminCollegeListEdit from "./components/admin/collegelistinfo/CollegeListEdit";
import StudentCollegeList from "./components/student/collegeList";
import StudentCollegeListIndex from "./components/student12/collegeList/index";
import StudentDeadlineIndex from "./components/student12/deadline/index";
import StudentFinAidIndex from "./components/student12/finaid/index";
import StudentCollegeProfile from "./components/student911/studentprofile/index";
import StudentActivitiesAndAwards from "./components/student12/activitiesandawards/index";
import Student911ActivitieAndReports from "./components/student911/activitiesandreports/index";

import Student911Layout from "./components/student911/layout";
import Student12Layout from "./components/student12/layout";

//import StudentCollegeList from "./components/student12/collegeList/CollegeList";
import StudentApplicationProfile from './components/student12/studentprofile_2'
import ParentProfile from './components/parent/editProfile'
import ParentEditProfile from './components/parent/editProfile/editProfile'
import ActivityTracker from './components/student/awards/awards'

import StudentGoalTracker from './components/student/awards/index'
import InstructorStudentAcademicAssessment from './components/instructor/studentGrid/studentacademicassessment'
import StudentAwardsEdit from './components/student/awardlist/awardlistedit'
import StudentTaskListWrapper from './components/student/taskAgendaNotes/studentactask'
import GlobalStudentTaskEdit from './components/pages/common/globalstudenttaskedit'
import StudentCoursesReport from './components/student/coursesreport'

const Approuter = () => {
	const [profile, setProfile] = React.useState()
	/*
    const value = React.useMemo(
      () => ({ profile, setProfile }),
      [profile]
    );
  */

	async function GetData() {
		const user = await getUserId()

		const userprofile = await getIdData(user)
		console.log('userprofile', userprofile)
		setProfile(userprofile[0])
	}

	React.useEffect(() => {
		//GetData();
	}, [])

	return (
		<UserProvider>
			<Routes>
				<Route path="/" element={<Login />} />
				<Route path="/home2" element={<Home2 />} />
				<Route path="/home3" element={<Home3 />} />
				<Route path="/home4" element={<Home4 />} />

				<Route path="/parent" element={<ParentLayout />}>
					{/* <Route index={true} element={<InstructorTaskManageList />} /> */}
					<Route index={true} element={<ParentStudentInfo />} />
					<Route path="parent-studentschedule">
						<Route path=":slug" element={<ParentStudentSchedule />} />
					</Route>
					<Route path="parent-studentnotes">
						<Route path=":slug" element={<ParentStudentNotes />} />
					</Route>
					<Route path="parent-studentagenda">
						<Route path=":slug" element={<ParentStudentAgenda />} />
					</Route>
					<Route path="parent-studenttask">
						<Route path=":slug" element={<ParentStudentTaskList />} />
					</Route>
					<Route path="student-profile">
						<Route path=":slug" element={<ParentStudentProfile />} />
					</Route>
					<Route path="student-profile_2">
						<Route path=":slug" element={<ParentStudentProfile_2 />} />
					</Route>
					<Route path="parent-profile" element={<ParentProfile />} />
					<Route path="parent-profile-edit" element={<ParentEditProfile />} />
				</Route>

				<Route path="/instructor" element={<InstructorLayout />}>
					{/* <Route index={true} element={<InstructorTaskManageList />} /> */}
					<Route index={true} element={<InstructorClassList />} />
					<Route path="instructor-profile" element={<InstructorProfile />} />
					<Route path="instructor-profile-edit" element={<InstructorEditProfile />} />
					{/*<Route index={true} element={<Dashboard />} />*/}
					<Route path="instructor-class" element={<InstructorClassList />} />
					<Route path="instructor-student-grid">
						<Route path=":slug" element={<InstructorStudentGrid />} />
					</Route>
					<Route path="instructor-studentdetail">
						<Route path=":slug" element={<InstructorStudentDetail />} />
					</Route>

					<Route path="instructor-desiredcolleges" element={<InstructorDesiredColleges />} />
					<Route path="instructor-desiredcolleges-edit">
						<Route path=":slug" element={<InstructorDesiredCollegesEdit />} />
					</Route>
					<Route path="instructor-studentcollegelist">
						<Route path=":slug" element={<InstructorStudentCollegeList />} />
					</Route>

					<Route path="instructor-studentbooklist">
						<Route path=":slug" element={<InstructorStudentBookList />} />
					</Route>

					<Route path="instructor-studentappcheck">
						<Route path=":slug" element={<InstructorStudentAppCheck />} />
					</Route>

					<Route path="instructor-studentprogresscheck">
						<Route path=":slug" element={<InstructorStudentProgressCheck />} />
					</Route>

					<Route path="instructor-studentactivty">
						<Route path=":slug" element={<InstructorStudentActivityList />} />
					</Route>

					<Route path="instructor-studentactivity-edit">
						<Route path=":slug/:status/:id" element={<InstructorStudentActivityEdit />} />
					</Route>

					<Route path="instructor-studentchecklist">
						<Route path=":slug" element={<InstructorStudentCheckList />} />
					</Route>

					<Route path="instructor-studentactivitiesandawards">
						<Route path=":slug" element={<InstructorStudentActivitiesAndAwardsIndex />} />
					</Route>

					<Route path="instructor-studentdeadlines">
						<Route path=":slug" element={<InstructorStudentDeadlines />} />
					</Route>

					<Route path="instructor-studentfinaid">
						<Route path=":slug" element={<InstructorStudentFinAid />} />
					</Route>

					<Route path="instructor-checklist-edit">
						<Route path=":slug/:status/:id" element={<GlobalCheckListEdit />} />
					</Route>
					<Route path="instructor-counselorcorner-edit">
						<Route path=":slug/:status/:id" element={<GlobalCounselorCornerEdit />} />
					</Route>

					<Route path="instructor-studentchecklist">
						<Route path=":slug" element={<InstructorStudentCheckList />} />
					</Route>

					<Route path="instructor-studentschedule">
						<Route path=":slug" element={<InstructorStudentSchedule />} />
					</Route>

					<Route path="instructor-checklist-edit">
						<Route path=":slug/:status/:id" element={<GlobalCheckListEdit />} />
					</Route>
					<Route path="instructor-studentsupplementalessay">
						<Route path=":slug" element={<InstructorStudentSupplementalEssay />} />
					</Route>

					<Route path="instructor-supplementalessay-edit">
						<Route path=":slug/:status/:id" element={<GlobalSupplementalEssayEdit />} />
					</Route>

					<Route path="instructor-studenttask">
						<Route path=":slug" element={<InstructorStudentTaskList />} />
					</Route>

					<Route path="college-list">
						<Route path=":slug" element={<InstStudentCollegeList />} />
					</Route>

					<Route path="instructor-studentnotes">
						<Route path=":slug" element={<InstructorStudentNotesList />} />
					</Route>

					<Route path="instructor-studentpersonalquestion">
						<Route path=":slug" element={<InstructorStudentPersonalQuestion />} />
					</Route>

					<Route path="instructor-addschedule" element={<InstructorNewSchedule />} />
					<Route path="instructor-scheduledays" element={<InstructorScheduleDays />} />
					<Route path="instructor-studentgoalgrades">
						<Route path=":slug" element={<InstructorStudentGoalGrades />} />
					</Route>

					<Route path="instructor-studentgradelist">
						<Route path=":slug" element={<InstructorStudentGradeList />} />
					</Route>

					<Route path="instructor-academicassessment">
						<Route path=":slug" element={<InstructorStudentAcademicAssessment />} />
					</Route>

					<Route path="instructor-studenttranskript">
						<Route path=":slug" element={<InstructorStudentTranskript />} />
					</Route>

					<Route path="instructor-studenttranskript-edit">
						<Route path=":slug" element={<InstructorStudentTranskriptEdit />} />
					</Route>

					<Route path="instructor-curriculumtable">
						<Route path=":slug" element={<InstructorCurriculumTable />} />
					</Route>
					<Route path="instructor-studentlessonforgrade">
						<Route path=":slug" element={<InstructorStudentLessonForGrade />} />
					</Route>

					<Route path="instructor-studentlessoneditforgrade">
						<Route path=":slug/:status" element={<InstructorStudentLessonEditForGrade />} />
					</Route>

					<Route path="instructor-studentlesson">
						<Route path=":slug" element={<InstructorStudentLesson />} />
					</Route>
					<Route path="instructor-studentcoursesreport">
						<Route path=":slug" element={<InstructorStudentCoursesReport />} />
					</Route>
					<Route path="instructor-studentsat">
						<Route path=":slug" element={<InstructorStudentSat />} />
					</Route>
					<Route path="instructor-studentcollegecourses">
						<Route path=":slug" element={<InstructorStudentCollegeCourses />} />
					</Route>
					<Route path="instructor-studentawards">
						<Route path=":slug" element={<StudentGoalTracker />} />
					</Route>
					<Route path="instructor-studentawards-edit">
						<Route path=":slug/:status/:id" element={<InstructorStudentAwardsListEdit />} />
					</Route>

					<Route path="instructor-studentprojects">
						<Route path=":slug" element={<InstructorStudentProjects />} />
					</Route>
					<Route path="instructor-studentcollegevisit">
						<Route path=":slug" element={<InstructorStudentCollegeVisit />} />
					</Route>
					<Route path="instructor-studentcalendar">
						<Route path=":slug" element={<InstructorStudentCalendar />} />
					</Route>
					<Route path="instructor-studentlor">
						<Route path=":slug" element={<InstructorStudentLor />} />
					</Route>
					<Route path="instructor-studentfinancialaid">
						<Route path=":slug" element={<InstructorStudentFinancialAid />} />
					</Route>

					<Route path="instructor-studentlessonedit">
						<Route path=":slug/:status" element={<InstructorStudentLessonEdit />} />
					</Route>

					<Route path="instructor-studenttaskedit">
						<Route path=":status" element={<GlobalStudentTaskEdit />} />
					</Route>

					<Route path="instructor-studentmainessay">
						<Route path=":slug" element={<InstructorStudentMainEssay />} />
					</Route>

					<Route path="instructor-studentadditionalinfo">
						<Route path=":slug" element={<InstructorStudentAdditionalInfo />} />
					</Route>

					<Route path="instructor-studentbragsheet">
						<Route path=":slug" element={<InstructorStudentBragSheet />} />
					</Route>

					<Route path="instructor-resource-edit">
						<Route path=":slug/:status/:id" element={<GlobalResourceEdit />} />
					</Route>

					<Route path="instructor-studentresource">
						<Route path=":slug" element={<InstructorStudentResource />} />
					</Route>

					<Route path="instructor-taskmanage" element={<InstructorTaskManageList />} />
					<Route path="instructor-addnewtask" element={<InstructorAddNewTask />} />

					<Route path="instructor-taskmanage-edit">
						<Route path=":slug/:type" element={<InstructorTaskManage />} />
					</Route>
					<Route path="instructor-taskmanagedetail">
						<Route path=":slug?" element={<InstructorTaskManageDetail />} />
					</Route>

					<Route path="instructor-notes" element={<InstructorNotes />} />
					<Route path="instructor-notes-edit">
						<Route path=":slug/:Id/:page" element={<InstructorNotesEdit />} />
					</Route>
					<Route path="/instructor/student-profile-edit/:id" element={<InstructorStudentUpdate />} />
				</Route>

				<Route path="/instructor-student-profile">
					<Route path=":slug" element={<InstructorStudentProfile />} />
				</Route>
				<Route path="/instructor-student-profile_2">
					<Route path=":slug" element={<InstructorStudentProfile_2 />} />
				</Route>

				<Route path="/instructor-list" element={<InstructorList />} />
				<Route path="/instructor-grid" element={<InstructorGrid />} />
				<Route path="/instructor-course" element={<InstructorCourse />} />

				{/* Pages */}
				<Route path="/come-soon" element={<ComingSoon />} />
				<Route path="*" element={<Error404 />} />
				<Route path="/error-500" element={<Error500 />} />
				<Route path="/under-construction" element={<UnderConstruction />} />
				<Route path="/support" element={<Support />} />
				<Route path="/login" element={<Login />} />
				<Route path="/register" element={<Register />} />
				<Route path="/newpassword" element={<NewPassword />} />

				<Route path="/register1" element={<RegisterOne />} />
				<Route path="/register2" element={<RegisterTwo />} />
				<Route path="/register3" element={<RegisterThree />} />
				<Route path="/register4" element={<RegisterFour />} />
				<Route path="/register5" element={<RegisterFive />} />
				<Route path="/forgot-password" element={<ForgotPassword />} />
				<Route path="/term-condition" element={<TermsCondition />} />
				<Route path="/privacy-policy" element={<PrivacyPolicy />} />

				{/* Admin Routes */}

				{/*Student Routes  */}

				<Route path="/admin" element={<AdminLayout />}>
					<Route path="admin-profile" element={<AdminProfile />} />
					<Route path="admin-profile-edit" element={<AdminProfileEdit />} />
					{/*<Route index={true} element={<DashboardAdmin />} />*/}
					<Route index={true} element={<AdminStudentGrid />} />

					<Route path="admin-studentedit" element={<AdminStudentEdit />} />

					<Route path="admin-studentstep2">
						<Route path=":slug/:type" element={<AdminAddStudentStep2 />} />
					</Route>
					<Route path="admin-studentstep3">
						<Route path=":slug" element={<AdminAddStudentStep3 />} />
					</Route>
					<Route path="admin-studentdetail">
						<Route path=":slug" element={<AdminStudentDetail />} />
					</Route>
					<Route path="admin-studentrolechange">
						<Route path=":slug" element={<AdminStudentRoleUpdate />} />
					</Route>
					<Route path="admin-parent">
						<Route path=":slug" element={<AdminParent />} />
					</Route>

					<Route path="admin-studentbooklist">
						<Route path=":slug" element={<AdminStudentBookList />} />
					</Route>

					<Route path="admin-studentaplicationprofile">
						<Route path=":slug" element={<AdminStudentAplicationProfile />} />
					</Route>

					<Route path="admin-studentcollegeprofile">
						<Route path=":slug" element={<AdminStudentCollegeProfile />} />
					</Route>

					<Route path="admin-studenttaskmanagement">
						<Route path=":slug" element={<AdminStudentTaskManagement />} />
					</Route>

					<Route path="admin-studentappcheck">
						<Route path=":slug" element={<AdminStudentAppCheck />} />
					</Route>

					<Route path="admin-studentpersonalquestion">
						<Route path=":slug" element={<AdminStudentPersonalQuestion />} />
					</Route>

					<Route path="admin-studentpersonalquestion-edit">
						<Route path=":slug" element={<AdminStudentPersonalQuestionEdit />} />
					</Route>

					<Route path="admin-studentgoalgrades">
						<Route path=":slug" element={<AdminStudentGoalGrades />} />
					</Route>

					<Route path="admin-studentgradelist">
						<Route path=":slug" element={<AdminStudentGradeList />} />
					</Route>

					<Route path="admin-counselorcorner">
						<Route path=":slug/:status/" element={<GlobalCounselorCorner slug={0} isAdmin={true} />} />
					</Route>

					<Route path="admin-counselorcorneredit">
						<Route path=":slug/:status/:id" element={<GlobalCounselorCornerEdit slug={0} isAdmin={true} id={0} />} />
					</Route>

					<Route path="admin-instructor-list" element={<AdminInstructorGrid />} />
					<Route path="admin-instructoredit" element={<AdminInstructorEdit />} />
					<Route path="admin-instructorstep2">
						<Route path=":slug/:type" element={<AdminAddInstructorStep2 />} />
					</Route>
					<Route path="admin-instructorstep3">
						<Route path=":slug" element={<AdminAddInstructorStep3 />} />
					</Route>

					<Route path="admin-instructordetail">
						<Route path=":slug" element={<AdminInstructorDetail />} />
					</Route>

					<Route path="admin-taskmanage" element={<TaskManageList />} />
					<Route path="admin-taskmanage-edit">
						<Route path=":slug" element={<TaskManage />} />
					</Route>
					<Route path="admin-taskmanagedetail">
						<Route path=":slug?" element={<TaskManageDetail />} />
					</Route>

					<Route path="admin-params" element={<AdminParameters />} />
					<Route path="admin-params-edit">
						<Route path=":slug" element={<AdminParametersEdit />} />
					</Route>

					<Route path="admin-booklist" element={<AdminBookList />} />
					<Route path="admin-booklist-edit">
						<Route path=":slug" element={<AdminBookListEdit />} />
					</Route>

					<Route path="admin-appcheck" element={<AdminAppCheck />} />
					<Route path="admin-appcheck-edit">
						<Route path=":slug/:cat" element={<AdminAppCheckEdit />} />
					</Route>

					<Route path="admin-class" element={<AdminClassList />} />
					<Route path="admin-classedit">
						<Route path=":slug" element={<AdminClassEdit />} />
					</Route>
					<Route path="admin-studenttoclass">
						<Route path=":slug" element={<AdminStudentToClass />} />
					</Route>

					<Route path="admin-desiredcolleges" element={<AdminDesiredColleges />} />
					<Route path="admin-desiredcolleges-edit">
						<Route path=":slug" element={<AdminDesiredCollegesEdit />} />
					</Route>
					<Route path="admin-collegelistinfo" element={<AdminCollegeList />} />
					<Route path="admin-collegelistinfo-edit">
						<Route path=":slug" element={<AdminCollegeListEdit />} />
					</Route>

					<Route path="admin-lessons" element={<AdminLessons />} />
					<Route path="admin-lessons-edit">
						<Route path=":slug/:cat" element={<AdminLessonsEdit />} />
					</Route>

					<Route path="admin-progress-check" element={<AdminProgressCheck />} />
				</Route>

				<Route path="/admin-student-profile">
					<Route path=":slug" element={<AdminStudentProfile />} />
				</Route>
				<Route path="/admin-student-list" element={<AdminStudentList />} />
				<Route path="/admin-dragdrop" element={<AdminDragDrop />} />

				{/* Instructor Routes */}
				<Route path="/instructor-dashboard" element={<Dashboard />} />
				<Route path="/instructor-list" element={<InstructorList />} />
				<Route path="/instructor-grid" element={<InstructorGrid />} />
				<Route path="/instructor-course" element={<InstructorCourse />} />
				<Route path="/instructor-reviews" element={<InstructorReviews />} />
				<Route path="/instructor-earnings" element={<InstructorEarnings />} />
				<Route path="/instructor-orders" element={<InstructorOrders />} />
				<Route path="/instructor-payouts" element={<InstructorPayouts />} />
				<Route path="/instructor-tickets" element={<InstructorTickets />} />
				{/*<Route path="/instructor-profile" element={<InstructorProfile2 />} />*/}

				<Route path="/instructor-security" element={<InstructorSecurity />} />
				<Route path="/instructor-social-profile" element={<InstructorSocialProfile />} />
				<Route path="/instructor-notifications" element={<InstructorNotification />} />
				<Route path="/instructor-chat" element={<InstructorChat />} />

				<Route path="/instructor-delete-profile" element={<InstructorDeleteProfile />} />
				<Route path="/instructor-edit" element={<InstructorEdit />} />
				<Route path="/instructor-grid-2" element={<InstructorGrid2 />} />
				<Route path="/instructor-linked-account" element={<InstructorLinkedAccount />} />
				<Route path="/instructor-new-tickets" element={<InstructorNewTickets />} />
				<Route path="/instructor-profile-privacy" element={<InstructorProfilePrivacy />} />

				<Route path="/instructor-student-list" element={<InstructorStudentList />} />
				<Route path="/deposit-instructor-dashboard" element={<InstructorDepositDashboard />} />

				<Route path="/dashboard-instructor" element={<DashboardInstructor />} />
				<Route path="/withdrawal-instructor" element={<WithdrawalInstructor />} />
				<Route path="/deposit-instructor" element={<DepositInstructor />} />
				<Route path="/transactions-instructor" element={<TransactionInstructor />} />
				<Route path="instructor-studentawards" element={<InstructorStudentAwards />} />

				{/*Student Routes  */}

				<Route path="/student" element={<StudentLayout />}>
					<Route index={true} element={<StudentTaskList />} />
					<Route path="student-profile" element={<StudentProfile />} />
					<Route path="student-profile-edit" element={<StudentProfileEdit />} />
					<Route path="student-booklist" element={<StudentBookList />} />
					<Route path="student-appcheck" element={<StudentAppCheckList />} />
					<Route path="`student-tasklist`" element={<StudentTaskList />} />
					<Route path="student-taskmanagedetail">
						<Route path=":slug?" element={<StudentTaskManageDetail />} />
					</Route>
					<Route path="student-lessonlist" element={<StudentLessonList />} />
					<Route path="student-test" element={<StudentTest />} />
					<Route path="student-lessons" element={<StudentLessons />} />
					<Route path="student-lessons-edit">
						<Route path=":slug/" element={<StudentLessonsEdit />} />
					</Route>

					<Route path="student-lessonsforgrade" element={<StudentLessonsForGrade />} />
					<Route path="student-lessonsforgrade-edit">
						<Route path=":slug/" element={<StudentLessonsEditForGrade />} />
					</Route>

					<Route path="student-transkript" element={<StudentTranskriptList />} />
					<Route path="student-transkript-edit">
						<Route path=":slug/" element={<StudentTranskriptEdit />} />
					</Route>
					<Route path="student-gradeinmonth" element={<StudentGradesInMonthEdit />} />
					<Route path="student-desiredcollegelist" element={<StudentDesiredCollegeList />} />
					<Route path="student-personal-questions" element={<StudentPersonelQuestionsList />} />
					<Route path="student-personal-questions-edit">
						<Route path=":slug/:Id" element={<StudentPersonalQuestionEdit />} />
					</Route>
					<Route path="student-goal-questions" element={<StudentGoalQuestionsList />} />
					<Route path="student-goal-questions-edit">
						<Route path=":slug/:Id" element={<StudentGoalQuestionEdit />} />
					</Route>
					<Route path="student-activity" element={<StudentActivityList />} />
					<Route path="student-activity-edit">
						<Route path=":slug/:Id" element={<StudentActivityEdit />} />
					</Route>
					<Route path="student-curriculum-table" element={<StudentCurriculumTable />} />
					<Route path="student-mainessay" element={<StudentMainEssay />} />
					<Route path="student-additionalinfo" element={<StudentAdditionalInfo />} />
					<Route path="student-schedulelist" element={<StudentScheduleList />} />

					<Route path="student-bragsheet" element={<StudentBragSheet />} />
					<Route path="student-resource" element={<StudentResource />} />

					<Route path="student-notes" element={<StudentNotes />} />
					<Route path="student-notes-edit">
						<Route path=":slug/:Id" element={<StudentNotesEdit />} />
					</Route>
					<Route path="student-checklist" element={<StudentCheckList />} />
					<Route path="student-checklist-edit">
						<Route path=":slug/:status/:id" element={<GlobalCheckListEdit />} />
					</Route>

					<Route path="student-supplementalessay" element={<StudentSupplementalEssay />} />
					<Route path="student-supplementalessay-edit">
						<Route path=":slug/:status/:id" element={<GlobalSupplementalEssayEdit />} />
					</Route>
				</Route>
				<Route path="/student12" element={<Student12Layout />}>
					<Route index={true} element={<StudentTaskList />} />
					<Route path="student-profile" element={<StudentProfile />} />
					<Route path="student-profile-edit" element={<StudentProfileEdit />} />
					<Route path="student-booklist" element={<StudentBookList />} />
					<Route path="student-appcheck" element={<StudentAppCheckList />} />
					<Route path="student-tasklist" element={<StudentTaskList />} />
					<Route path="student-taskmanagedetail">
						<Route path=":slug?" element={<StudentTaskManageDetail />} />
					</Route>
					<Route path="student-awards-edit">
						<Route path=":slug/:id" element={<StudentAwardsEdit />} />
					</Route>
					<Route path="student-lessonlist" element={<StudentLessonList />} />
					<Route path="student-test" element={<StudentTest />} />
					<Route path="student-lessons" element={<StudentLessons />} />
					<Route path="college_list">
						<Route path=":id/" element={<StudentCollegeList />} />
					</Route>
					<Route path="student-lessons-edit">
						<Route path=":slug/" element={<StudentLessonsEdit />} />
					</Route>

					<Route path="student-lessonsforgrade" element={<StudentLessonsForGrade />} />
					<Route path="student-transkript" element={<StudentTranskriptList />} />
					<Route path="student-transkript-edit">
						<Route path=":slug/" element={<StudentTranskriptEdit />} />
					</Route>
					<Route path="student-gradeinmonth" element={<StudentGradesInMonthEdit />} />
					<Route path="student-desiredcollegelist" element={<StudentDesiredCollegeList />} />
					<Route path="student-personal-questions" element={<StudentPersonelQuestionsList />} />
					<Route path="student-personal-questions-edit">
						<Route path=":slug/:Id" element={<StudentPersonalQuestionEdit />} />
					</Route>
					<Route path="student-goal-questions" element={<StudentGoalQuestionsList />} />
					<Route path="student-goal-questions-edit">
						<Route path=":slug/:Id" element={<StudentGoalQuestionEdit />} />
					</Route>
					<Route path="student-activitiesandawards" element={<StudentActivitiesAndAwards />} />
					<Route path="student-activity" element={<StudentActivityList />} />
					<Route path="student-activity-edit">
						<Route path=":slug/:Id" element={<StudentActivityEdit />} />
					</Route>
					<Route path="student-curriculum-table" element={<StudentCurriculumTable />} />
					<Route path="student-mainessay" element={<StudentMainEssay />} />
					<Route path="student-additionalinfo" element={<StudentAdditionalInfo />} />
					<Route path="student-schedulelist" element={<StudentScheduleList />} />

					<Route path="student-bragsheet" element={<StudentBragSheet />} />
					<Route path="student-resource" element={<StudentResource />} />

					<Route path="student-notes" element={<StudentNotes />} />
					<Route path="student-notes-edit">
						<Route path=":slug/:Id" element={<StudentNotesEdit />} />
					</Route>

					<Route path="student-task" element={<StudentTask />} />

					<Route path="student-collegelist" element={<StudentCollegeListIndex />} />
					<Route path="student-deadline" element={<StudentDeadlineIndex />} />
					<Route path="student-finaid" element={<StudentFinAidIndex />} />
					<Route path="student-checklist" element={<StudentCheckList />} />
					<Route path="student-application-profile">
						<Route path=":slug" element={<StudentApplicationProfile />} />
					</Route>

					<Route path="student-checklist-edit">
						<Route path=":slug/:status/:id" element={<GlobalCheckListEdit />} />
					</Route>

					<Route path="student-supplementalessay" element={<StudentSupplementalEssay />} />
					<Route path="student-supplementalessay-edit">
						<Route path=":slug/:status/:id" element={<GlobalSupplementalEssayEdit />} />
					</Route>
				</Route>

				<Route path="/student911" element={<Student911Layout />}>
					<Route index={true} element={<StudentTaskList />} />
					<Route path="student-profile" element={<StudentProfile />} />
					<Route path="student-profile-edit" element={<StudentProfileEdit />} />
					<Route path="student-booklist" element={<StudentBookList />} />
					<Route path="student-tasklist" element={<StudentTaskList />} />
					<Route path="student-taskmanagedetail">
						<Route path=":slug?" element={<StudentTaskManageDetail />} />
					</Route>
					<Route path="student-lessonlist" element={<StudentLessonList />} />
					<Route path="student-test" element={<StudentTest />} />
					<Route path="student-lessons" element={<StudentLessons />} />
					<Route path="student-coursesreport" element={<StudentCoursesReport />} />
					<Route path="student-collegelist" element={<StudentCollegeListIndex />} />
					<Route path="student-awards" element={<StudentGoalTracker />} />
					<Route path="student-awards-edit">
						<Route path=":slug/:id" element={<StudentAwardsEdit />} />
					</Route>
					<Route path="student-collegeprofile" element={<StudentCollegeProfile />} />

					<Route path="student-lessons-edit">
						<Route path=":slug/" element={<StudentLessonsEdit />} />
					</Route>

					<Route path="student-lessonsforgrade" element={<StudentLessonsForGrade />} />
					<Route path="student-lessonsforgrade-edit">
						<Route path=":slug/" element={<StudentLessonsEditForGrade />} />
					</Route>

					<Route path="student-transkript" element={<StudentTranskriptList />} />
					<Route path="student-transkript-edit">
						<Route path=":slug/" element={<StudentTranskriptEdit />} />
					</Route>
					<Route path="student-gradeinmonth" element={<StudentGradesInMonthEdit />} />
					<Route path="student-desiredcollegelist" element={<StudentDesiredCollegeList />} />
					<Route path="student-personal-questions" element={<StudentPersonelQuestionsList />} />
					<Route path="student-personal-questions-edit">
						<Route path=":slug/:Id" element={<StudentPersonalQuestionEdit />} />
					</Route>
					<Route path="student-goal-questions" element={<StudentGoalQuestionsList />} />
					<Route path="student-goal-questions-edit">
						<Route path=":slug/:Id" element={<StudentGoalQuestionEdit />} />
					</Route>
					<Route path="student-activitiesandreports" element={<Student911ActivitieAndReports />} />
					<Route path="student-activity" element={<StudentActivityList />} />
					<Route path="student-activity-edit">
						<Route path=":slug/:Id" element={<StudentActivityEdit />} />
					</Route>
					<Route path="student-activity-reports" element={<StudentActivityReportsList />} />
					<Route path="student-schedulelist" element={<StudentScheduleList />} />

					<Route path="student-resource" element={<StudentResource />} />

					<Route path="student-task" element={<StudentTask />} />

					<Route path="student-notes" element={<StudentNotes />} />
					<Route path="student-notes-edit">
						<Route path=":slug/:Id" element={<StudentNotesEdit />} />
					</Route>
				</Route>

				<Route path="/setting-student-notification" element={<StudentNotification />} />
				<Route path="/setting-student-privacy" element={<StudentPrivacy />} />
				<Route path="/setting-student-referral" element={<StudentReferral />} />
				<Route path="/setting-student-security" element={<StudentSecurity />} />

				<Route path="/setting-student-subscription" element={<StudentSubscription />} />
				<Route path="/setting-support-new-tickets" element={<StudentNewTickets />} />
				<Route path="/setting-support-tickets" element={<StudentTickets />} />
				<Route path="/setting-support-view-tickets" element={<StudentViewTickets />} />

				<Route path="/students-grid" element={<StudentsGrid />} />
				<Route path="/students-grid2" element={<StudentsGrid2 />} />
				<Route path="/students-list" element={<StudentsList />} />
			</Routes>
		</UserProvider>
	)
}

export default Approuter;
